import * as React from 'react';
import { Typography } from '@material-ui/core';
import { InferenceResultSubdiv } from '../../models/InferenceResultSubdiv';

import './InferenceResultView.css';
import { InferenceAdditionalResultSubdiv } from '../../models/InferenceAdditionalResultSubdiv';

interface OwnProps {
  result: InferenceResultSubdiv[];
  additionalResult: InferenceAdditionalResultSubdiv;
  // 結果表を非表示にする（主に印刷用）
  hideTable?: boolean;
  // 画像を非表示にする（主に印刷用）
  hideImages?: boolean;
};

export const InferenceResultSubdivView: React.SFC<OwnProps> = (props: OwnProps) => {
  if (!props.result || !(props.result.length > 0)) {
    return (<Typography variant="body2">データ無し</Typography>);
  }
  // 追加評価情報
  const additionalLeft = (props.additionalResult.each_position_score || {}).left;
  const additionalTop = (props.additionalResult.each_position_score || {}).top;
  const additionalRight = (props.additionalResult.each_position_score || {}).right;
  const finallyScore = props.additionalResult.finally_score;
  return (
    <div>
      {
        props.hideTable
          ? null
          : (
            <table style={{ width: '100%',  borderCollapse: 'collapse'}} className="inferenceresulttable">
              <thead>
                <tr>
                  <th>観察項目</th>
                  <th style={{ width: '90px'}}>重み係数</th>
                  <th style={{ width: '90px'}}>左肩</th>
                  <th style={{ width: '90px'}}>天端</th>
                  <th style={{ width: '90px'}}>右肩</th>
                </tr>
              </thead>
              <tbody>
              {
                props.result.map((item, index) => {
                  const scoreLeft = (item.result_score && item.result_score.left)
                      ? `${item.result_score.left.mode}（${item.result_score.left.mean}）`: '';
                  const scoreTop = (item.result_score && item.result_score.top)
                      ? `${item.result_score.top.mode}（${item.result_score.top.mean}）`: '';
                  const scoreRight = (item.result_score && item.result_score.right)
                      ? `${item.result_score.right.mode}（${item.result_score.right.mean}）`: '';
                  return (<tr key={`item_${index}`} className={(index % 2 === 0) ? 'even' : ''}>
                    <td>{item.observation_name}</td>
                    <td style={{ textAlign: 'center'}}>{item.weight}</td>
                    <td style={{ textAlign: 'center'}}>{scoreLeft}</td>
                    <td style={{ textAlign: 'center'}}>{scoreTop}</td>
                    <td style={{ textAlign: 'center'}}>{scoreRight}</td>
                  </tr>);
                })
              }
                <tr style={{ borderTop: 'solid 3px black' }}>
                  <th colSpan={2} style={{ textAlign: 'right' }}>左肩、天端、右肩の総合評価点</th>
                  <td style={{ textAlign: 'center'}}>{additionalLeft}</td>
                  <td style={{ textAlign: 'center'}}>{additionalTop}</td>
                  <td style={{ textAlign: 'center'}}>{additionalRight}</td>
                </tr>
                <tr>
                  <th colSpan={2} style={{ textAlign: 'right' }}>切羽全体の評価点</th>
                  <td style={{ textAlign: 'center'}} colSpan={3}>{finallyScore}</td>
                </tr>
              </tbody>
            </table>
          )
      }
      {/* <hr/> */}
      {
        props.hideImages
          ? null
          : props.result.map((item, index) => {
              const url = item.overlay_img_presigned_url;
              return (
                <div key={`images_${index}`}>
                  <Typography variant="h6">{item.observation_name}</Typography>
                  {
                    (url)
                      ? <img src={url} style={{ maxWidth: '100%' }}/>
                      : <span>画像なし</span>
                  }

                </div>
              );
            })
      }

    </div>
  );
};




// WEBPACK FOOTER //
// ./src/components/parts/InferenceResultSubdivView.tsx